module.exports = __webpack_public_path__ + "img/logosttrarcos.04f1db2f.png";